import {
    AggregatedByAndSubPlotLabel,
    AggregatedByAndSubPlotValue,
    Dma,
    Region,
    SelectionAge,
    SelectionAlcoBeverages,
    SelectionBeautyCare,
    SelectionCategory,
    SelectionClothingFashion,
    SelectionConsumerElectro,
    SelectionEatingAndDrinking,
    SelectionFinancialProducts,
    SelectionGrocery,
    SelectionHeritage,
    SelectionHighlighted,
    SelectionIncome,
    SelectionInsurance,
    SelectionNonAlcogolic,
    SelectionPanelSexValue,
    SelectionPlotlyLegend,
    SelectionScenarioSex,
    SelectionSports,
    SelectionSubscription,
    Tab,
} from 'utils';

export const wppThemeSetupFromCssUS = () => {
    let Theme: any = {};

    if (document.readyState === 'complete') {
        let index = 0;
        const loadedModel = [
            ['--wpp-dataviz-color-cat-1', '--wpp-dataviz-color-cat-neutral-1'],
            ['--wpp-dataviz-color-cat-2', '--wpp-dataviz-color-cat-neutral-2'],
            ['--wpp-dataviz-color-cat-3', '--wpp-dataviz-color-cat-neutral-3'],
            ['--wpp-dataviz-color-cat-4', '--wpp-dataviz-color-cat-neutral-4'],
            ['--wpp-dataviz-color-cat-5', '--wpp-dataviz-color-cat-neutral-5'],
            ['--wpp-dataviz-color-cat-6', '--wpp-dataviz-color-cat-neutral-6'],
            ['--wpp-dataviz-color-cat-7', '--wpp-dataviz-color-cat-neutral-7'],
            ['--wpp-dataviz-color-cat-8', '--wpp-dataviz-color-cat-neutral-8'],
            ['--wpp-dataviz-color-cat-9', '--wpp-dataviz-color-cat-neutral-9'],
            ['--wpp-dataviz-color-cat-10', '--wpp-dataviz-color-cat-neutral-10'],
            '--wpp-dataviz-color-cat-light-1',
            '--wpp-dataviz-color-cat-light-2',
            '--wpp-dataviz-color-cat-light-3',
            '--wpp-dataviz-color-cat-light-4',
            '--wpp-dataviz-color-cat-light-5',
            '--wpp-dataviz-color-cat-light-6',
            '--wpp-dataviz-color-cat-light-7',
            '--wpp-dataviz-color-cat-light-8',
            '--wpp-dataviz-color-cat-light-9',
            '--wpp-dataviz-color-cat-light-10',
            '--wpp-dataviz-color-cat-dark-1',
            '--wpp-dataviz-color-cat-dark-2',
            '--wpp-dataviz-color-cat-dark-3',
            '--wpp-dataviz-color-cat-dark-4',
            '--wpp-dataviz-color-cat-dark-5',
            '--wpp-dataviz-color-cat-dark-6',
            '--wpp-dataviz-color-cat-dark-7',
            '--wpp-dataviz-color-cat-dark-8',
            '--wpp-dataviz-color-cat-dark-9',
            '--wpp-dataviz-color-cat-dark-10',
        ];

        loadedModel.map((a: any) => {
            const color =
                typeof a === 'string'
                    ? window.getComputedStyle(document.body).getPropertyValue(a)
                    : window.getComputedStyle(document.body).getPropertyValue(a[0]) ||
                      window.getComputedStyle(document.body).getPropertyValue(a[1]);
            const propertyKey =
                (a.includes('dark') && '--wpp-dataviz-color-cat-dark') ||
                (a.includes('light') && '--wpp-dataviz-color-cat-light') ||
                '--wpp-dataviz-color-cat';
            Theme[`${propertyKey}-${(index % 10) + 1}`] = color;
            index++;
        });
    } else {
        Theme = {
            '--wpp-dataviz-color-cat-dark-1': '#8508E8',
            '--wpp-dataviz-color-cat-dark-2': '#B03883',
            '--wpp-dataviz-color-cat-dark-3': '#D10015',
            '--wpp-dataviz-color-cat-dark-4': '#BD490A',
            '--wpp-dataviz-color-cat-dark-5': '#8B561A',
            '--wpp-dataviz-color-cat-dark-6': '#4D7C0F',
            '--wpp-dataviz-color-cat-dark-7': '#15803D',
            '--wpp-dataviz-color-cat-dark-8': '#0E7490',
            '--wpp-dataviz-color-cat-dark-9': '#4453C9',
            '--wpp-dataviz-color-cat-dark-10': '#5E5557',
            '--wpp-dataviz-color-cat-light-1': '#ECDCFE',
            '--wpp-dataviz-color-cat-light-2': '#F2D0EC',
            '--wpp-dataviz-color-cat-light-3': '#FFCCD1',
            '--wpp-dataviz-color-cat-light-4': '#FED7AA',
            '--wpp-dataviz-color-cat-light-5': '#FEF08A',
            '--wpp-dataviz-color-cat-light-6': '#D9F99D',
            '--wpp-dataviz-color-cat-light-7': '#BEF4D2',
            '--wpp-dataviz-color-cat-light-8': '#A5F3FC',
            '--wpp-dataviz-color-cat-light-9': '#BFDBF9',
            '--wpp-dataviz-color-cat-light-10': '#DEDCE0',
            '--wpp-dataviz-color-cat-1': '#C18DFC',
            '--wpp-dataviz-color-cat-2': '#DB77BA',
            '--wpp-dataviz-color-cat-3': '#FF6B7A',
            '--wpp-dataviz-color-cat-4': '#F57A38',
            '--wpp-dataviz-color-cat-5': '#CA8A04',
            '--wpp-dataviz-color-cat-6': '#68A512',
            '--wpp-dataviz-color-cat-7': '#22C55E',
            '--wpp-dataviz-color-cat-8': '#06B6D4',
            '--wpp-dataviz-color-cat-9': '#6993E4',
            '--wpp-dataviz-color-cat-10': '#919196',
        };
    }

    return {
        [AggregatedByAndSubPlotValue.ALL_POPULATION]: Theme['--wpp-dataviz-color-cat-10'],
        [SelectionHeritage.HISPANIC_ANY_RACE]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionHeritage.WHITE]: Theme['--wpp-dataviz-color-cat-light-10'],
        [SelectionHeritage.BLACK]: Theme['--wpp-dataviz-color-cat-9'],
        [SelectionHeritage.ASIAN]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionIncome.GROUP_ABOVE_100k]: Theme['--wpp-dataviz-color-cat-8'],
        [SelectionIncome.GROUP_75k_TO_100k]: Theme['--wpp-dataviz-color-cat-9'],
        [SelectionIncome.GROUP_50k_TO_75k]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionIncome.GROUP_25k_TO_50k]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionIncome.GROUP_10k_TO_25k]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionIncome.GROUP_LESS_10k]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionCategory.ALCOGOLIC_BEVERAGES]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionCategory.CONSUMER_ELECTRONICS]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionCategory.GROCERY]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionCategory.NON_ALCOHOLIC_BEVERAGES]: Theme['--wpp-dataviz-color-cat-9'],
        [SelectionPlotlyLegend.RESTRICTED_SOCIOECONOMIC]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionPlotlyLegend.NO_SOCIOECONOMIC]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionPlotlyLegend.PERSISTENT_SOCIOECONOMIC]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionPlotlyLegend.RAPID_SOCIOECONOMIC]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionPlotlyLegend.BASELINE]: Theme['--wpp-dataviz-color-cat-1'],
        [AggregatedByAndSubPlotLabel.TOTAL_POPULATION]: Theme['--wpp-dataviz-color-cat-10'],
        [AggregatedByAndSubPlotLabel.COMBINED_MULTICULTURAL]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionPlotlyLegend.ADULT_POPULATION_ABOVE_16]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionPlotlyLegend.ADULT_POPULATION_ABOVE_15]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionPlotlyLegend.MIXED]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionPlotlyLegend.SOUTH_ASIAN_INDIAN]: Theme['--wpp-dataviz-color-cat-dark-7'],
        [SelectionPlotlyLegend.SOUTH_ASIAN_PAKISTANI]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionPlotlyLegend.SOUTH_ASIAN_BANGLADESHI]: Theme['--wpp-dataviz-color-cat-light-7'],
        [AggregatedByAndSubPlotValue.ETHNICALLY_GROUPS]: Theme['--wpp-dataviz-color-cat-10'],
        [SelectionHeritage.MIXED_AND_OTHER]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionPlotlyLegend.EAST_AND_SOUTHEAST_ASIAN]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionPlotlyLegend.MIDDLE_EASTERN]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionPlotlyLegend.HIGH_INCOME]: Theme['--wpp-dataviz-color-cat-dark-1'],
        [SelectionPlotlyLegend.MID_LEVEL_INCOME]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionPlotlyLegend.LOW_INCOME]: Theme['--wpp-dataviz-color-cat-light-1'],
        [SelectionCategory.BEAUTY_AND_PERSONAL_CARE]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionCategory.CLOTHING_AND_FASHION]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionCategory.EATING_AND_DRINKING_OUT]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionCategory.FINANCIAL_PRODUCTS_AND_SERVICES]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionPlotlyLegend.GROCERIES]: Theme['--wpp-dataviz-color-cat-9'],
        [Tab.POPULATION]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionPlotlyLegend.PER_PERSON_SPEND]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionPlotlyLegend.SPEND]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionHighlighted.DEMOGRAPHIC_POPULATION]: Theme['--wpp-dataviz-color-cat-dark-10'],
        [SelectionPlotlyLegend.CATEGORY_SPEND_CUMULATIVE]: Theme['--wpp-dataviz-color-cat-dark-10'],
        [SelectionPlotlyLegend.CATEGORY_SPEND_PER_ANNUM]: Theme['--wpp-dataviz-color-cat-dark-10'],
        [SelectionScenarioSex.FEMALES]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionPanelSexValue.FEMALE]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionScenarioSex.MALES]: Theme['--wpp-dataviz-color-cat-4'],
        [SelectionPanelSexValue.MALE]: Theme['--wpp-dataviz-color-cat-4'],
        [SelectionAge.GROUP_LESS_16]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionAge.GROUP_LESS_18]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionAge.GROUP_18_24]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionAge.GROUP_25_34]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionAge.GROUP_35_49]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionAge.GROUP_50_64]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionAge.GROUP_65_PLUS]: Theme['--wpp-dataviz-color-cat-9'],
        [SelectionBeautyCare.HAIR_AND_COSMETICS]: Theme['--wpp-dataviz-color-cat-dark-9'],
        [SelectionBeautyCare.TOILETRIES_AND_SOAP]: Theme['--wpp-dataviz-color-cat-9'],
        [SelectionBeautyCare.TREATMENTS]: Theme['--wpp-dataviz-color-cat-light-9'],
        [SelectionPlotlyLegend.ADULT]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionPlotlyLegend.CHILDREN]: Theme['--wpp-dataviz-color-cat-light-5'],
        [SelectionEatingAndDrinking.DRINKING_OUT_ALCOHOL]: Theme['--wpp-dataviz-color-cat-dark-2'],
        [SelectionEatingAndDrinking.EATING_OUT]: Theme['--wpp-dataviz-color-cat-2'],
        [SelectionEatingAndDrinking.TAKEAWAY]: Theme['--wpp-dataviz-color-cat-light-2'],
        [SelectionCategory.INSURANCE]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionFinancialProducts.SAVINGS]: Theme['--wpp-dataviz-color-cat-light-7'],
        [SelectionGrocery.ALCOHOL_AT_HOME]: Theme['--wpp-dataviz-color-cat-8'],
        [SelectionGrocery.BABYCARE]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionGrocery.CLEANING_PRODUCTS]: Theme['--wpp-dataviz-color-cat-6'],
        [SelectionGrocery.FOOD]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionGrocery.PETCARE]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionPlotlyLegend.TOBACO_AND_NARCOTICS]: Theme['--wpp-dataviz-color-cat-2'],
        [SelectionPlotlyLegend.TOILET_PAPER]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionConsumerElectro.AUDIO_EQUIP]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionConsumerElectro.CELLPHONES]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionConsumerElectro.COMPUTERS_AND_LAPTOPS]: Theme['--wpp-dataviz-color-cat-6'],
        [SelectionConsumerElectro.PERSONAL_CARE]: Theme['--wpp-dataviz-color-cat-4'],
        [SelectionConsumerElectro.SMALL_KITCHEN_APPLIANCES]: Theme['--wpp-dataviz-color-cat-8'],
        [SelectionConsumerElectro.TELEVISIONS]: Theme['--wpp-dataviz-color-cat-2'],
        [SelectionConsumerElectro.VIDEO_GAMES]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionConsumerElectro.E_READERS]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionGrocery.BAKED_GOODS]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionGrocery.CLEANING_AND_HYGIENE]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionGrocery.GENERAL_FOOD]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionGrocery.PET_FOOD]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionGrocery.SWEET_AND_SNACKS]: Theme['--wpp-dataviz-color-cat-9'],
        [SelectionNonAlcogolic.COFFEE]: Theme['--wpp-dataviz-color-cat-6'],
        [SelectionNonAlcogolic.COLA]: Theme['--wpp-dataviz-color-cat-2'],
        [SelectionNonAlcogolic.JUICE]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionNonAlcogolic.OTHER]: Theme['--wpp-dataviz-color-cat-4'],
        [SelectionNonAlcogolic.SODA]: Theme['--wpp-dataviz-color-cat-8'],
        [SelectionNonAlcogolic.SPORTS_DRINKS]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionNonAlcogolic.TEA]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionNonAlcogolic.WATER]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionInsurance.HEALTH]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionInsurance.HOMEOWNER]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionInsurance.LIFE_AND_PERSONAL]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionInsurance.VEHICLE]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionAlcoBeverages.BEER_AND_ALE]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionAlcoBeverages.OTHER]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionAlcoBeverages.WINE]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionHeritage.MIXED_AND_OTHER_RACES]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionPlotlyLegend.MIXED_AND_ADDITIONAL_RACES]: Theme['--wpp-dataviz-color-cat-5'],
        [Region.MIDWEST]: Theme['--wpp-dataviz-color-cat-7'],
        [Region.NORTHEAST]: Theme['--wpp-dataviz-color-cat-5'],
        [Region.SOUTH]: Theme['--wpp-dataviz-color-cat-3'],
        [Region.WEST]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionPlotlyLegend.ADULT_18_PLUS]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionPlotlyLegend.ADULT_16_PLUS]: Theme['--wpp-dataviz-color-cat-3'],
        [Dma.NEW_YORK_NY]: Theme['--wpp-dataviz-color-cat-1'],
        [Dma.LOS_ANGELES_CA]: Theme['--wpp-dataviz-color-cat-2'],
        [Dma.CHICAGO_IL]: Theme['--wpp-dataviz-color-cat-3'],
        [Dma.PHILADELPHIA_PA]: Theme['--wpp-dataviz-color-cat-4'],
        [Dma.DALLAS_FT]: Theme['--wpp-dataviz-color-cat-5'],
        [Dma.ATLANTA_GA]: Theme['--wpp-dataviz-color-cat-6'],
        [Dma.HOUSTON_TX]: Theme['--wpp-dataviz-color-cat-7'],
        [Dma.WASHINGTON_DC]: Theme['--wpp-dataviz-color-cat-8'],
        [Dma.BOSTON_MA]: Theme['--wpp-dataviz-color-cat-9'],
        [Dma.SAN_FRANCISCO_CA]: Theme['--wpp-dataviz-color-cat-10'],
        [SelectionSubscription.AUDIO_STREAMING]: Theme['--wpp-dataviz-color-cat-9'],
        [SelectionSubscription.BOOKS_AND_EBOOKS]: Theme['--wpp-dataviz-color-cat-8'],
        [SelectionSubscription.SHOPPING_MEMBERSHIP]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionSubscription.VIDEO_STREAMING]: Theme['--wpp-dataviz-color-cat-4'],
        [SelectionSports.CLUB_MEMBERSHIPS]: Theme['--wpp-dataviz-color-cat-6'],
        [SelectionSports.EVENT_TICKETS]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionSports.PARTICIPATION_FEES]: Theme['--wpp-dataviz-color-cat-4'],
    };
};

export const wppThemeSetupFromCssUK = () => {
    let Theme: any = {};

    if (document.readyState === 'complete') {
        let index = 0;
        const loadedModel = [
            ['--wpp-dataviz-color-cat-1', '--wpp-dataviz-color-cat-neutral-1'],
            ['--wpp-dataviz-color-cat-2', '--wpp-dataviz-color-cat-neutral-2'],
            ['--wpp-dataviz-color-cat-3', '--wpp-dataviz-color-cat-neutral-3'],
            ['--wpp-dataviz-color-cat-4', '--wpp-dataviz-color-cat-neutral-4'],
            ['--wpp-dataviz-color-cat-5', '--wpp-dataviz-color-cat-neutral-5'],
            ['--wpp-dataviz-color-cat-6', '--wpp-dataviz-color-cat-neutral-6'],
            ['--wpp-dataviz-color-cat-7', '--wpp-dataviz-color-cat-neutral-7'],
            ['--wpp-dataviz-color-cat-8', '--wpp-dataviz-color-cat-neutral-8'],
            ['--wpp-dataviz-color-cat-9', '--wpp-dataviz-color-cat-neutral-9'],
            ['--wpp-dataviz-color-cat-10', '--wpp-dataviz-color-cat-neutral-10'],
            '--wpp-dataviz-color-cat-light-1',
            '--wpp-dataviz-color-cat-light-2',
            '--wpp-dataviz-color-cat-light-3',
            '--wpp-dataviz-color-cat-light-4',
            '--wpp-dataviz-color-cat-light-5',
            '--wpp-dataviz-color-cat-light-6',
            '--wpp-dataviz-color-cat-light-7',
            '--wpp-dataviz-color-cat-light-8',
            '--wpp-dataviz-color-cat-light-9',
            '--wpp-dataviz-color-cat-light-10',
            '--wpp-dataviz-color-cat-dark-1',
            '--wpp-dataviz-color-cat-dark-2',
            '--wpp-dataviz-color-cat-dark-3',
            '--wpp-dataviz-color-cat-dark-4',
            '--wpp-dataviz-color-cat-dark-5',
            '--wpp-dataviz-color-cat-dark-6',
            '--wpp-dataviz-color-cat-dark-7',
            '--wpp-dataviz-color-cat-dark-8',
            '--wpp-dataviz-color-cat-dark-9',
            '--wpp-dataviz-color-cat-dark-10',
        ];

        loadedModel.map((a: any) => {
            const color =
                typeof a === 'string'
                    ? window.getComputedStyle(document.body).getPropertyValue(a)
                    : window.getComputedStyle(document.body).getPropertyValue(a[0]) ||
                      window.getComputedStyle(document.body).getPropertyValue(a[1]);
            const propertyKey =
                (a.includes('dark') && '--wpp-dataviz-color-cat-dark') ||
                (a.includes('light') && '--wpp-dataviz-color-cat-light') ||
                '--wpp-dataviz-color-cat';
            Theme[`${propertyKey}-${(index % 10) + 1}`] = color;
            index++;
        });
    } else {
        Theme = {
            '--wpp-dataviz-color-cat-dark-1': '#8508E8',
            '--wpp-dataviz-color-cat-dark-2': '#B03883',
            '--wpp-dataviz-color-cat-dark-3': '#D10015',
            '--wpp-dataviz-color-cat-dark-4': '#BD490A',
            '--wpp-dataviz-color-cat-dark-5': '#8B561A',
            '--wpp-dataviz-color-cat-dark-6': '#4D7C0F',
            '--wpp-dataviz-color-cat-dark-7': '#15803D',
            '--wpp-dataviz-color-cat-dark-8': '#0E7490',
            '--wpp-dataviz-color-cat-dark-9': '#4453C9',
            '--wpp-dataviz-color-cat-dark-10': '#5E5557',
            '--wpp-dataviz-color-cat-light-1': '#ECDCFE',
            '--wpp-dataviz-color-cat-light-2': '#F2D0EC',
            '--wpp-dataviz-color-cat-light-3': '#FFCCD1',
            '--wpp-dataviz-color-cat-light-4': '#FED7AA',
            '--wpp-dataviz-color-cat-light-5': '#FEF08A',
            '--wpp-dataviz-color-cat-light-6': '#D9F99D',
            '--wpp-dataviz-color-cat-light-7': '#BEF4D2',
            '--wpp-dataviz-color-cat-light-8': '#A5F3FC',
            '--wpp-dataviz-color-cat-light-9': '#BFDBF9',
            '--wpp-dataviz-color-cat-light-10': '#DEDCE0',
            '--wpp-dataviz-color-cat-1': '#C18DFC',
            '--wpp-dataviz-color-cat-2': '#DB77BA',
            '--wpp-dataviz-color-cat-3': '#FF6B7A',
            '--wpp-dataviz-color-cat-4': '#F57A38',
            '--wpp-dataviz-color-cat-5': '#CA8A04',
            '--wpp-dataviz-color-cat-6': '#68A512',
            '--wpp-dataviz-color-cat-7': '#22C55E',
            '--wpp-dataviz-color-cat-8': '#06B6D4',
            '--wpp-dataviz-color-cat-9': '#6993E4',
            '--wpp-dataviz-color-cat-10': '#919196',
        };
    }

    return {
        [AggregatedByAndSubPlotLabel.TOTAL_POPULATION]: Theme['--wpp-dataviz-color-cat-10'],
        [SelectionPlotlyLegend.ADULT_16_PLUS]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionPlotlyLegend.ADULT_15_PLUS]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionHeritage.HISPANIC_ANY_RACE]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionHeritage.WHITE]: Theme['--wpp-dataviz-color-cat-light-8'],
        [SelectionHeritage.BLACK]: Theme['--wpp-dataviz-color-cat-9'],
        [SelectionHeritage.ASIAN]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionHeritage.MIXED]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionClothingFashion.ADULT]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionClothingFashion.CHILDREN]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionIncome.GROUP_ABOVE_100k]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionIncome.GROUP_75k_TO_100k]: Theme['--wpp-dataviz-color-cat-2'],
        [SelectionIncome.GROUP_50k_TO_75k]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionIncome.GROUP_25k_TO_50k]: Theme['--wpp-dataviz-color-cat-4'],
        [SelectionIncome.GROUP_10k_TO_25k]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionIncome.GROUP_LESS_10k]: Theme['--wpp-dataviz-color-cat-6'],
        [SelectionCategory.ALCOGOLIC_BEVERAGES]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionCategory.CONSUMER_ELECTRONICS]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionCategory.GROCERY]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionCategory.NON_ALCOHOLIC_BEVERAGES]: Theme['--wpp-dataviz-color-cat-9'],
        [SelectionPlotlyLegend.RESTRICTED_SOCIOECONOMIC]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionPlotlyLegend.SOUTH_ASIAN_INDIAN]: Theme['--wpp-dataviz-color-cat-dark-7'],
        [SelectionPlotlyLegend.SOUTH_ASIAN_PAKISTANI]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionPlotlyLegend.SOUTH_ASIAN_BANGLADESHI]: Theme['--wpp-dataviz-color-cat-light-7'],
        [SelectionPlotlyLegend.MINORITY_GROUPS]: Theme['--wpp-dataviz-color-cat-6'],
        [SelectionHeritage.MIXED_AND_OTHER]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionHeritage.EAST_AND_SOUTH_ASIAN]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionHeritage.MIDDLE_EASTERN]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionPlotlyLegend.NO_SOCIOECONOMIC]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionPlotlyLegend.PERSISTENT_SOCIOECONOMIC]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionPlotlyLegend.RAPID_SOCIOECONOMIC]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionPlotlyLegend.BASELINE]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionPlotlyLegend.HIGH_INCOME]: Theme['--wpp-dataviz-color-cat-dark-1'],
        [SelectionPlotlyLegend.MID_LEVEL_INCOME]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionPlotlyLegend.LOW_INCOME]: Theme['--wpp-dataviz-color-cat-light-1'],
        [SelectionCategory.BEAUTY_AND_PERSONAL_CARE]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionCategory.CLOTHING_AND_FASHION]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionCategory.EATING_AND_DRINKING_OUT]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionCategory.FINANCIAL_PRODUCTS_AND_SERVICES]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionCategory.GROCERIES]: Theme['--wpp-dataviz-color-cat-9'],
        [Tab.POPULATION]: Theme['--wpp-dataviz-color-cat-1'],
        [AggregatedByAndSubPlotLabel.COMBINED_MULTICULTURAL]: Theme['--wpp-dataviz-color-cat-7'],
        [AggregatedByAndSubPlotValue.ETHNICALLY_GROUPS]: Theme['--wpp-dataviz-color-cat-10'],
        [SelectionPlotlyLegend.SPEND]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionHighlighted.DEMOGRAPHIC_POPULATION]: Theme['--wpp-dataviz-color-cat-dark-10'],
        [SelectionPlotlyLegend.CATEGORY_SPEND_CUMULATIVE]: Theme['--wpp-dataviz-color-cat-dark-10'],
        [SelectionPlotlyLegend.CATEGORY_SPEND_PER_ANNUM]: Theme['--wpp-dataviz-color-cat-dark-10'],
        [SelectionPanelSexValue.FEMALE]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionPanelSexValue.MALE]: Theme['--wpp-dataviz-color-cat-4'],
        [SelectionAge.GROUP_LESS_30]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionAge.GROUP_16_24]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionAge.GROUP_25_29]: Theme['--wpp-dataviz-color-cat-2'],
        [SelectionAge.GROUP_30_39]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionAge.GROUP_40_49]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionAge.GROUP_50_64]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionAge.GROUP_65_PLUS]: Theme['--wpp-dataviz-color-cat-9'],
        [SelectionAge.GROUP_15_20]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionAge.GROUP_21_30]: Theme['--wpp-dataviz-color-cat-2'],
        [SelectionAge.GROUP_31_40]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionAge.GROUP_41_50]: Theme['--wpp-dataviz-color-cat-4'],
        [SelectionAge.GROUP_51_60]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionAge.GROUP_LESS_60]: Theme['--wpp-dataviz-color-cat-6'],
        [SelectionBeautyCare.HAIR_AND_COSMETICS]: Theme['--wpp-dataviz-color-cat-dark-9'],
        [SelectionBeautyCare.TOILETRIES_AND_SOAP]: Theme['--wpp-dataviz-color-cat-9'],
        [SelectionBeautyCare.TREATMENTS]: Theme['--wpp-dataviz-color-cat-light-9'],
        [SelectionPlotlyLegend.ADULT]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionPlotlyLegend.CHILDREN]: Theme['--wpp-dataviz-color-cat-light-5'],
        [SelectionEatingAndDrinking.DRINKING_OUT_ALCOHOL]: Theme['--wpp-dataviz-color-cat-dark-2'],
        [SelectionEatingAndDrinking.EATING_OUT]: Theme['--wpp-dataviz-color-cat-2'],
        [SelectionEatingAndDrinking.TAKEAWAY]: Theme['--wpp-dataviz-color-cat-light-2'],
        [SelectionEatingAndDrinking.DRINKING_OUT_ALCOHOL_WITHOUT_PARENTHESES]:
            Theme['--wpp-dataviz-color-cat-dark-2'],
        [SelectionFinancialProducts.INSURANCE]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionFinancialProducts.SAVINGS]: Theme['--wpp-dataviz-color-cat-light-7'],
        [SelectionGrocery.ALCOHOL_AT_HOME_WITHOUT_BRACES]: Theme['--wpp-dataviz-color-cat-8'],
        [SelectionGrocery.BABYCARE]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionGrocery.CLEANING_PRODUCTS]: Theme['--wpp-dataviz-color-cat-6'],
        [SelectionGrocery.FOOD]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionGrocery.NEWSPAPERS_AND_MAGAZINES]: Theme['--wpp-dataviz-color-cat-4'],
        [SelectionGrocery.PETCARE]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionPlotlyLegend.TOBACO_AND_NARCOTICS]: Theme['--wpp-dataviz-color-cat-2'],
        [SelectionPlotlyLegend.TOILET_PAPER]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionConsumerElectro.AUDIO_EQUIP]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionConsumerElectro.CELLPHONES]: Theme['--wpp-dataviz-color-cat-2'],
        [SelectionConsumerElectro.COMPUTERS_AND_LAPTOPS]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionConsumerElectro.PERSONAL_CARE]: Theme['--wpp-dataviz-color-cat-4'],
        [SelectionConsumerElectro.SMALL_KITCHEN_APPLIANCES]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionConsumerElectro.TELEVISIONS]: Theme['--wpp-dataviz-color-cat-6'],
        [SelectionConsumerElectro.VIDEO_GAMES]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionConsumerElectro.E_READERS]: Theme['--wpp-dataviz-color-cat-8'],
        [SelectionGrocery.BAKED_GOODS]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionGrocery.CLEANING_AND_HYGIENE]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionGrocery.GENERAL_FOOD]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionGrocery.PET_FOOD]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionGrocery.SWEET_AND_SNACKS]: Theme['--wpp-dataviz-color-cat-9'],
        [SelectionNonAlcogolic.COFFEE]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionNonAlcogolic.COLA]: Theme['--wpp-dataviz-color-cat-2'],
        [SelectionNonAlcogolic.JUICE]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionNonAlcogolic.OTHER]: Theme['--wpp-dataviz-color-cat-4'],
        [SelectionNonAlcogolic.SODA]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionNonAlcogolic.SPORTS_DRINKS]: Theme['--wpp-dataviz-color-cat-6'],
        [SelectionNonAlcogolic.TEA]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionNonAlcogolic.WATER]: Theme['--wpp-dataviz-color-cat-8'],
        [SelectionInsurance.HEALTH]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionInsurance.HOMEOWNER]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionInsurance.LIFE_AND_PERSONAL]: Theme['--wpp-dataviz-color-cat-5'],
        [SelectionInsurance.VEHICLE]: Theme['--wpp-dataviz-color-cat-7'],
        [SelectionAlcoBeverages.BEER_AND_ALE]: Theme['--wpp-dataviz-color-cat-1'],
        [SelectionAlcoBeverages.OTHER]: Theme['--wpp-dataviz-color-cat-3'],
        [SelectionAlcoBeverages.WINE]: Theme['--wpp-dataviz-color-cat-5'],
    };
};
